import {createEventBus} from '@malt/vue-event-bus/create-event-bus';
import {} from '../logged/features/aside-menu/aside-menu.types';
import type {Location} from '@malt/nuxt-common-components-module/types';

export type FocusSearchJobInputParams = {enableZoom?: boolean};

export type NavbarSearchRequestedPayload = {
    query: string;
    location: Location | null;
    sourceComponent: string;
};

type Events = {
    'focus-search-location-input': undefined;
    'focus-search-job-input': FocusSearchJobInputParams | undefined;
    'navbar-search-form-submit': undefined;
    'navbar-search-requested': NavbarSearchRequestedPayload;
    'open-availibility-dialog': {source: string};
    'expand-client-onboarding-walkthrough': undefined;
    /**
     * From any application, use this event to programmatically reduce the desktop navigation
     */
    'request:navbar-desktop-reduced': undefined;
    'request:navbar-desktop-full': undefined;
    'request:navbar-desktop-full-with-tab-expanded': {tab: string};
    'request:navbar-header-get-started-on-malt-onboarding': undefined;
    'request:navbar-toggle-on-mobile': {isOpen: boolean};
    'request:navbar-umbrella-contract-acceptance-watch': {registrationNumber: string};

    'availability-navbar:update': undefined;
    'navbar-logged:mounted': undefined;
};

export const navbarEventBus = createEventBus<Events>();
